import type { BillSummary } from './types';

export const mockBillSummaries: BillSummary[] = [
  {
    id: '1',
    billMonth: '2025-01',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    status: '出账中',
    totalAmount: 125000,
    totalPoints: 0,
    discountAmount: 5000,
    discountPoints: 0,
    actualAmount: 120000,
    actualPoints: 0,
  },
  {
    id: '2',
    billMonth: '2024-12',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    status: '已出账',
    totalAmount: 98000,
    totalPoints: 0,
    discountAmount: 3000,
    discountPoints: 0,
    actualAmount: 95000,
    actualPoints: 0,
  },
  {
    id: '3',
    billMonth: '2025-01',
    tenantId: 'T10002',
    tenantName: '实验中学',
    userId: 'U10002',
    userName: '李四',
    status: '出账中',
    totalAmount: 0,
    totalPoints: 250000,
    discountAmount: 0,
    discountPoints: 10000,
    actualAmount: 0,
    actualPoints: 240000,
  },
  {
    id: '4',
    billMonth: '2024-12',
    tenantId: 'T10002',
    tenantName: '实验中学',
    userId: 'U10002',
    userName: '李四',
    status: '已出账',
    totalAmount: 0,
    totalPoints: 180000,
    discountAmount: 0,
    discountPoints: 8000,
    actualAmount: 0,
    actualPoints: 172000,
  },
  {
    id: '5',
    billMonth: '2025-01',
    tenantId: 'T10003',
    tenantName: '互联网公司',
    userId: 'U10004',
    userName: '赵六',
    status: '出账中',
    totalAmount: 85000,
    totalPoints: 0,
    discountAmount: 2000,
    discountPoints: 0,
    actualAmount: 83000,
    actualPoints: 0,
  },
  {
    id: '6',
    billMonth: '2024-12',
    tenantId: 'T10003',
    tenantName: '互联网公司',
    userId: 'U10004',
    userName: '赵六',
    status: '已出账',
    totalAmount: 72000,
    totalPoints: 0,
    discountAmount: 1500,
    discountPoints: 0,
    actualAmount: 70500,
    actualPoints: 0,
  },
  {
    id: '7',
    billMonth: '2024-11',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    status: '已出账',
    totalAmount: 105000,
    totalPoints: 0,
    discountAmount: 4000,
    discountPoints: 0,
    actualAmount: 101000,
    actualPoints: 0,
  },
  {
    id: '8',
    billMonth: '2024-11',
    tenantId: 'T10002',
    tenantName: '实验中学',
    userId: 'U10002',
    userName: '李四',
    status: '已出账',
    totalAmount: 0,
    totalPoints: 200000,
    discountAmount: 0,
    discountPoints: 9000,
    actualAmount: 0,
    actualPoints: 191000,
  },
];
